import { request } from '@/shared/api';
export function assignBm(agentId, managerId) {
    return request('/api/v1/bm-assignments', {
        method: 'POST',
        body: JSON.stringify({ agentId, managerId }),
    });
}
